import { Suspense, useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AdminNavbar } from "./AdminNavbar";
import { supabase } from "@/lib/supabase/client";
import { AppLoader } from "@/components/ui/app-loader";

export default function AdminLayout() {
  const [isCheckingSession, setIsCheckingSession] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // 1. Initial check
    supabase.auth.getSession().then(({ data: { session } }) => {
      setIsAuthenticated(!!session);
      setIsCheckingSession(false);
    });

    // 2. Listen for changes
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setIsAuthenticated(!!session);
      setIsCheckingSession(false);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (isCheckingSession) {
    return <AppLoader className="min-h-screen" label="Session prüfen" />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <div className="min-h-screen bg-background text-foreground">
      <AdminNavbar />
      <main className="min-h-screen p-4 pt-24 md:ml-64 md:p-8 md:pt-8">
        <Suspense fallback={<AppLoader label="Admin laden" />}>
          <Outlet />
        </Suspense>
      </main>
    </div>
  );
}
